import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum PaymentMethod {
  Undefined = 0,
  Credit = 1,
  Debit = 2,
  BankSlip = 3,
  BRCode = 6,
  CoBillingTIM = 7,
}
EnumDescriptions.setDescriptions(PaymentMethod, [
  i18n.t('enums.undefined'),
  i18n.t('enums.credit'),
  i18n.t('enums.debit'),
  i18n.t('enums.bank_slip'),
  i18n.t('enums.br_code'),
  i18n.t('enums.co_billing_tim'),
]);
